// 관리자 운영설정 API 래퍼.
// 단일 행 store_settings 의 조회/전체 갱신만 노출한다.

import type { StoreSettingsDto, StoreSettingsInput } from "@oo/shared";
import { api, apiRequest } from "@/api/client.ts";

// 운영설정 단일 행 조회.
export async function getStoreSettings(): Promise<StoreSettingsDto> {
  const data = await api.get<{ settings: StoreSettingsDto }>("/admin/store-settings");
  return data.settings;
}

// 운영설정 전체 갱신 (PUT).
export async function putStoreSettings(input: StoreSettingsInput): Promise<StoreSettingsDto> {
  // api 헬퍼에는 PUT 단축형이 없어 apiRequest 직접 호출.
  const data = await apiRequest<{ settings: StoreSettingsDto }>("/admin/store-settings", {
    method: "PUT",
    body: input,
  });
  return data.settings;
}
